<div>
    <form [formGroup]="form" (submit)="applyDateFilter()" class="filtros">
        <mat-form-field>
            <input matInput placeholder="Fecha desde" [title]="tooltip_fecha_desde" [matDatepicker]="picker1"
                formControlName="fromDate" required (click)="picker1.open()">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Fecha hasta" [title]="tooltip_fecha_hasta" [matDatepicker]="picker2"
                formControlName="toDate" required (click)="picker2.open()">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <button class="button-form" mat-raised-button [title]="tooltip_filtrar"
            (click)="applyDateFilter()" [disabled]="form.invalid">Filtrar</button>
        <button mat-raised-button (click)="clearDateInput()" [title]="tooltip_limpiar_filtros"
            type="button" [disabled]="form.invalid">Limpiar filtros</button>
    </form>
    <mat-form-field>
        <input matInput type="text" #filter (keyup)="doFilter(filter.value)" [title]="tooltip_buscar"
            placeholder="Buscar">
    </mat-form-field>
</div>
<div>
    <h2>Tus solicitudes</h2>
    <div class="buttons">
        <button mat-raised-button type="button" (click)="Exportar()">Exportar a excel</button>
        <div></div>
        <button mat-raised-button type="button" (click)="ExportarCargueMasivo()">Exportar formato cargue masivo</button>
    </div>
    <div class="responsiveTable">
        <table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc">
            <!-- <ng-container matColumnDef="Id">
                <th mat-header-cell *matHeaderCellDef> Id </th>
                <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
            </ng-container> -->
            <ng-container matColumnDef="NombreCompleto">
                <th mat-header-cell *matHeaderCellDef> Nombre completo</th>
                <td mat-cell *matCellDef="let element"> {{element.NombreCompleto}} </td>
            </ng-container>
            <ng-container matColumnDef="Identificacion">
                <th mat-header-cell *matHeaderCellDef> Número de documento </th>
                <td mat-cell *matCellDef="let element"> {{element.Identificacion}} </td>
            </ng-container>
            <ng-container matColumnDef="Correo">
                <th mat-header-cell *matHeaderCellDef> Correo </th>
                <td mat-cell *matCellDef="let element"> {{element.Correo}} </td>
            </ng-container>
            <ng-container matColumnDef="Celular">
                <th mat-header-cell *matHeaderCellDef> Celular </th>
                <td mat-cell *matCellDef="let element"> {{element.Celular}} </td>
            </ng-container>
            <ng-container matColumnDef="Direccion">
                <th mat-header-cell *matHeaderCellDef> Direccion </th>
                <td mat-cell *matCellDef="let element"> {{element.Direccion}} </td>
            </ng-container>
            <ng-container matColumnDef="EsPropietario">
                <th mat-header-cell *matHeaderCellDef> ¿Es Propietario? </th>
                <td mat-cell *matCellDef="let element"> {{element.EsPropietario}} </td>
            </ng-container>
            <ng-container matColumnDef="NumeroCuenta">
                <th mat-header-cell *matHeaderCellDef> Numero cuenta </th>
                <td mat-cell *matCellDef="let element"> {{element.NumeroCuenta}} </td>
            </ng-container>
            <ng-container matColumnDef="AutorizaInfo">
                <th mat-header-cell *matHeaderCellDef> ¿Autoriza notificación? </th>
                <td mat-cell *matCellDef="let element"> {{element.AutorizaInfo}} </td>
            </ng-container>
            <ng-container matColumnDef="FechaCreacion">
                <th mat-header-cell *matHeaderCellDef> Fecha creacion </th>
                <td mat-cell *matCellDef="let element"> {{element.FechaCreacion}} </td>
            </ng-container>
            <ng-container matColumnDef="Telefono">
                <th mat-header-cell *matHeaderCellDef> Telefono </th>
                <td mat-cell *matCellDef="let element"> {{element.Telefono}} </td>
            </ng-container>
            <ng-container matColumnDef="AceptaTratDatosPer">
                <th mat-header-cell *matHeaderCellDef> ¿Numero tratamiento de datos personales? </th>
                <td mat-cell *matCellDef="let element"> {{element.AceptaTratDatosPer}} </td>
            </ng-container>
            <ng-container matColumnDef="RecibirFactElect">
                <th mat-header-cell *matHeaderCellDef> ¿Acepta recibir factura electrónica? </th>
                <td mat-cell *matCellDef="let element"> {{element.RecibirFactElect}} </td>
            </ng-container>
            <ng-container matColumnDef="MatCatastral">
                <th mat-header-cell *matHeaderCellDef> Matrícula catastral </th>
                <td mat-cell *matCellDef="let element"> {{element.MatCatastral}} </td>
            </ng-container>
            <ng-container matColumnDef="CodigoVerificacion">
                <th mat-header-cell *matHeaderCellDef> Codigo verificacion </th>
                <td mat-cell *matCellDef="let element"> {{element.CodigoVerificacion}} </td>
            </ng-container>
            <ng-container matColumnDef="EmailVerificate">
                <th mat-header-cell *matHeaderCellDef> Correo verificado </th>
                <td mat-cell *matCellDef="let element"> {{element.EmailVerificate}} </td>
            </ng-container>
            <ng-container matColumnDef="FechaVerification">
                <th mat-header-cell *matHeaderCellDef> Fecha verificación correo </th>
                <td mat-cell *matCellDef="let element"> {{element.FechaVerification}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10"></mat-paginator>
</div>